module.exports = __webpack_public_path__ + "static/media/PLAYZIDO_logo_endemol.fc961ea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/PLAYZIDO_logo_endemol.png
// module id = 449
// module chunks = 0